import React from 'react';
import { MapPin, Home, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
interface ProjectCardProps {
  title: string;
  location: string;
  status: 'Selesai' | 'Berjalan' | 'Segera' | 'Completed' | 'Ongoing' | 'Coming Soon';
  type: string;
  imageColor?: string;
  units?: string;
}
export function ProjectCard({
  title,
  location,
  status,
  type,
  imageColor = 'bg-neutral-100',
  units
}: ProjectCardProps) {
  const {
    t
  } = useLanguage();
  const statusColors = {
    Selesai: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    Completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    Berjalan: 'bg-blue-50 text-blue-700 border-blue-200',
    Ongoing: 'bg-blue-50 text-blue-700 border-blue-200',
    Segera: 'bg-amber-50 text-amber-700 border-amber-200',
    'Coming Soon': 'bg-amber-50 text-amber-700 border-amber-200'
  };
  return <div className="bg-white rounded-card overflow-hidden border border-neutral-200 shadow-corporate card-hover flex flex-col h-full" data-id="element-214">
      {/* Image Area */}
      <div className={`relative h-56 w-full ${imageColor}`} data-id="element-215">
        {/* Status badge */}
        <span className={`absolute top-4 right-4 px-3 py-1 rounded-md text-xs font-semibold border ${statusColors[status]}`} data-id="element-216">
          {status}
        </span>

        {/* Type badge */}
        <div className="absolute bottom-4 left-4 px-3 py-1 rounded-md bg-white text-primary text-xs font-bold shadow-corporate" data-id="element-217">
          {type}
        </div>
      </div>

      <div className="p-6 flex-1 flex flex-col" data-id="element-218">
        <h3 className="text-xl font-heading font-semibold text-gray-900 mb-4" data-id="element-219">
          {title}
        </h3>

        <div className="space-y-3 mb-6 flex-1" data-id="element-220">
          <div className="flex items-start text-gray-600 text-sm" data-id="element-221">
            <MapPin className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0 text-gray-400" strokeWidth={2} data-id="element-222" />
            <span className="leading-relaxed" data-id="element-223">{location}</span>
          </div>
          {units && <div className="flex items-center text-gray-600 text-sm" data-id="element-224">
              <Home className="w-4 h-4 mr-2 flex-shrink-0 text-gray-400" strokeWidth={2} data-id="element-225" />
              <span data-id="element-226">{units} Unit</span>
            </div>}
        </div>

        {/* CTA Link */}
        <Link to="/proyek" className="inline-flex items-center text-sm font-semibold text-primary hover:text-primary-dark transition-colors duration-250" data-id="element-227">
          <span className="mr-2" data-id="element-228">{t('Lihat Detail', 'View Details')}</span>
          <ArrowRight className="w-4 h-4" strokeWidth={2} data-id="element-229" />
        </Link>
      </div>
    </div>;
}